/* Sunny theme: cart drawer, product options, gallery, filters */
(function () {
  'use strict';
  var S = window.sunny || { routes: {}, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#Toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ---------- money ---------- */
  function fmt(n, d) { return n.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function money(cents) {
    var f = S.moneyFormat || '${{amount}}', n = cents / 100;
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, type) {
      if (type === 'amount_no_decimals') return fmt(Math.round(n), 0);
      if (type === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      if (type === 'amount_no_decimals_with_comma_separator') return fmt(Math.round(n), 0).replace(/,/g, '.');
      return fmt(n, 2);
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('#CartDrawer');
  var SECTIONS = 'cart-drawer,header';
  function openCart() { if (drawer && !drawer.open && drawer.showModal) drawer.showModal(); }
  function closeCart() { if (drawer && drawer.open) drawer.close(); }

  function applySections(sections) {
    if (!sections) return false;
    if (sections['cart-drawer'] && drawer) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      ['[data-cart-lines]', '[data-cart-foot]'].forEach(function (sel) {
        var next = $(sel, doc), cur = $(sel, drawer);
        if (next && cur) cur.innerHTML = next.innerHTML;
      });
    }
    if (sections['header']) {
      var hdoc = new DOMParser().parseFromString(sections['header'], 'text/html');
      var nc = $('[data-cart-count]', hdoc), cc = $('[data-cart-count]');
      if (nc && cc) { cc.textContent = nc.textContent; cc.hidden = nc.hasAttribute('hidden'); }
    }
    return true;
  }

  function cartRequest(url, opts) {
    return fetch(url, opts).then(function (r) { return r.json(); });
  }

  function addToCart(formData) {
    formData.append('sections', SECTIONS);
    formData.append('sections_url', window.location.pathname);
    return cartRequest(S.routes.cart_add, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: formData
    }).then(function (res) {
      if (res.status || res.description) { toast(res.description || S.strings.error); return false; }
      if (!applySections(res.sections)) { window.location.href = S.routes.cart; return true; }
      openCart();
      return true;
    }).catch(function () { toast(S.strings.error); return false; });
  }

  function changeLine(line, qty) {
    cartRequest(S.routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: SECTIONS, sections_url: window.location.pathname })
    }).then(function (res) {
      if (res.status || res.description) { toast(res.description || S.strings.error); return; }
      applySections(res.sections);
    }).catch(function () { toast(S.strings.error); });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open && drawer && !document.body.classList.contains('template-cart')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    if (e.target === drawer) { closeCart(); return; }

    var lineBtn = e.target.closest('[data-line]');
    if (lineBtn && drawer && drawer.contains(lineBtn)) {
      changeLine(parseInt(lineBtn.getAttribute('data-line'), 10), parseInt(lineBtn.getAttribute('data-qty'), 10));
      return;
    }

    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      var fd = new FormData();
      fd.append('id', quick.getAttribute('data-variant-id'));
      fd.append('quantity', '1');
      quick.disabled = true;
      addToCart(fd).then(function (ok) {
        quick.disabled = false;
        if (ok) toast(quick.getAttribute('data-name') + ' ' + S.strings.added);
      });
      return;
    }

    /* product filter chips */
    var chip = e.target.closest('[data-filter]');
    if (chip) {
      var root = chip.closest('[data-product-filter]');
      if (!root) return;
      var val = chip.getAttribute('data-filter');
      $$('.chip', root).forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      $$('[data-grid] .card', root).forEach(function (card) {
        card.hidden = !(val === 'all' || card.getAttribute('data-type') === val);
      });
    }
  });

  /* ---------- product page ---------- */
  function initProduct(root) {
    var form = $('form[data-type="add-to-cart-form"]', root.parentNode) || $('form.pp-form', document);
    var jsonEl = $('[data-product-json]');
    if (!form || !jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var invMap = {};
    var invEl = $('[data-variant-inventory]');
    if (invEl) { try { invMap = JSON.parse(invEl.textContent); } catch (err) {} }
    var isPreorderCollection = root.getAttribute('data-preorder-collection') === 'true';
    var idInput = $('[data-variant-id]', form);
    var priceEl = $('[data-price]'), compareEl = $('[data-compare-price]');
    var btn = $('[data-add-button]', form);
    var main = $('[data-product-main]');
    var thumbs = $('[data-thumbs]');

    function selectedOptions() {
      var groups = $$('.opt-group', form);
      return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
    }
    function findVariant() {
      var sel = selectedOptions();
      if (!sel.length) return product.variants[0];
      return product.variants.filter(function (v) {
        return sel.every(function (val, i) { return v['option' + (i + 1)] === val; });
      })[0];
    }
    function showMedia(src, alt, id) {
      if (main && src) { main.src = src; if (alt) main.alt = alt; }
      if (thumbs) $$('button', thumbs).forEach(function (b) { b.setAttribute('aria-current', String(b.getAttribute('data-media-id') === String(id))); });
    }
    function update() {
      var v = findVariant();
      $$('.opt', form).forEach(function (l) { var i = $('input', l); l.classList.toggle('is-selected', !!(i && i.checked)); });
      if (!v) { btn.disabled = true; btn.textContent = S.strings.soldOut; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) { var on = v.compare_at_price && v.compare_at_price > v.price; compareEl.hidden = !on; if (on) compareEl.textContent = money(v.compare_at_price); }
      btn.disabled = !v.available;
      var inv = invMap[v.id] || { quantity: 0, policy: 'deny' };
      var preorder = v.available && (isPreorderCollection || (inv.quantity <= 0 && inv.policy === 'continue'));
      btn.textContent = preorder ? S.strings.preOrder : (v.available ? S.strings.addToCart : S.strings.soldOut);
      var note = form.parentNode.querySelector('[data-preorder-note]');
      if (note) note.hidden = !preorder;
      if (v.featured_media && thumbs) {
        var t = $('[data-media-id="' + v.featured_media.id + '"]', thumbs);
        if (t) showMedia(t.getAttribute('data-src'), t.getAttribute('data-alt'), v.featured_media.id);
      }
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
    }
    form.addEventListener('change', function (e) { if (e.target.matches('[data-option]')) update(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      addToCart(new FormData(form)).then(function (ok) {
        btn.disabled = false;
        if (ok) toast(product.title + ' ' + S.strings.added);
      });
    });
    if (thumbs) thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-media-id]'); if (!b) return;
      showMedia(b.getAttribute('data-src'), b.getAttribute('data-alt'), b.getAttribute('data-media-id'));
    });
    update();
  }
  $$('[data-product-root]').forEach(initProduct);

  /* theme editor: re-init after section reload */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-product-root]', e.target).forEach(initProduct);
  });
})();
